module.exports = __webpack_public_path__ + "static/media/100gba.65f4290e.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/100gba.png
// module id = 140
// module chunks = 0